// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mail_item {
  width: 100%;
  background: none !important;
  padding: 0 !important;
  margin: 0 !important;
}
.mail_item ion-card {
  width: -webkit-fill-available;
  margin: 0;
  margin-top: 20px;
  border-radius: 6px;
  cursor: pointer;
}

.inline_card_details {
  display: inline-flex;
  background: #dab39e;
  padding: 10px;
  border-radius: 6px;
  width: 100%;
  margin-top: 10px;
}
.inline_card_details h1 {
  width: 70%;
  text-align: left;
  font-size: 12px;
  margin-top: 6px;
  text-transform: uppercase;
  margin-left: 5px;
  font-weight: 800;
  color: #fff2e5;
}
.inline_card_details img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.inline_jazz {
  width: 100%;
  display: inline-flex;
  grid-gap: 30px;
  text-align: left;
}
.inline_jazz ion-avatar {
  margin-top: 2px;
  min-height: 60px;
  min-width: 60px;
  max-height: 60px;
  max-width: 60px;
}
.inline_jazz p {
  display: -webkit-box;
  max-width: 200px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-top: 10px;
}
.inline_jazz .time {
  font-size: 12px;
  color: #c4c4c4;
  display: block;
  margin-top: 10px;
}

.image_thumb {
  width: 100px;
  margin-top: 10px;
}

h4 {
  font-weight: bold;
  text-transform: uppercase;
}

.trash_icon {
  color: #c8b4a1;
  position: absolute;
  right: 20px;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0;
}

.mail_card_cntn {
  width: 90%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/mail-card/mail-card.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EAEA,2BAAA;EACA,qBAAA;EACA,oBAAA;AAAJ;AAEI;EACI,6BAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAAR;;AAIA;EACI,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EAEA,WAAA;EACA,gBAAA;AAFJ;AAII;EACI,UAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAFR;AAKI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAHR;;AAOA;EACI,WAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;AAJJ;AAMI;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAJR;AAOI;EACI,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;AALR;AAQI;EACI,eAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AANR;;AAUA;EACI,YAAA;EACA,gBAAA;AAPJ;;AAUA;EACI,iBAAA;EACA,yBAAA;AAPJ;;AAUA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EAAA,kBAAA;EACA,SAAA;AAPJ;;AAUA;EACI,UAAA;AAPJ","sourcesContent":[".mail_item {\n    width: 100%;\n\n    background: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n\n    ion-card {\n        width: -webkit-fill-available;\n        margin: 0;\n        margin-top: 20px;\n        border-radius: 6px;\n        cursor: pointer;\n    }\n}\n\n.inline_card_details {\n    display: inline-flex;\n    background: #dab39e;\n    padding: 10px;\n    border-radius: 6px;\n    //width: 55vw;\n    width: 100%;\n    margin-top: 10px;\n\n    h1 {\n        width: 70%;\n        text-align: left;\n        font-size: 12px;\n        margin-top: 6px;\n        text-transform: uppercase;\n        margin-left: 5px;\n        font-weight: 800;\n        color: #fff2e5;\n    }\n\n    img {\n        width: 40px;\n        height: 40px;\n        object-fit: contain;\n    }\n}\n\n.inline_jazz {\n    width: 100%;\n    display: inline-flex;\n    grid-gap: 30px;\n    text-align: left;\n\n    ion-avatar {\n        margin-top: 2px;\n        min-height: 60px;\n        min-width: 60px;\n        max-height: 60px;\n        max-width: 60px;\n    }\n\n    p {\n        display: -webkit-box;\n        max-width: 200px;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        margin-top: 10px;\n    }\n\n    .time {\n        font-size: 12px;\n        color: #c4c4c4;\n        display: block;\n        margin-top: 10px;\n    }\n}\n\n.image_thumb {\n    width: 100px;\n    margin-top: 10px;\n}\n\nh4 {\n    font-weight: bold;\n    text-transform: uppercase;\n}\n\n.trash_icon {\n    color: #c8b4a1;\n    position: absolute;\n    right: 20px;\n    width: fit-content;\n    margin: 0;\n}\n\n.mail_card_cntn {\n    width: 90%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
